module.exports = __webpack_public_path__ + "img/Screenshot from 2018-11-05 13-35-24.2ac167a6.png";